import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DetailSidebarContent } from '@/components/map/details/DetailSidebarContent';
import { RmvStationLink } from '@/components/map/details/RmvStationLink';
import { StationDetailContent } from '@/components/map/details/content/StationDetailContent';
import { StationDetailTable } from '@/components/map/details/table/StationDetailTable';
import { ButtonLink } from '@/components/router/ButtonLink';
import { useAbility } from '@/hooks/useAbility';
import { Action, Subject } from '@/modules/api/backend';
import { backendApiStationsFindOneOptions } from '@/modules/api/backend/@tanstack/react-query.gen';
import { getMapLayer } from '@/utils/getMapLayer';

export const Route = createFileRoute('/_public/_map/_sidebar/stations/$stationId')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const { stationId } = Route.useParams();
  const { ability } = useAbility();

  const { data: station } = useSuspenseQuery(
    backendApiStationsFindOneOptions({
      path: { stationId },
      query: { parkAndRideFacilities: true, parkAndRideFacilitiesPublication: true },
    }),
  );

  return (
    <DetailSidebarContent mapLayer={getMapLayer(station)} title={station.name}>
      <StationDetailContent doubleSpacing station={station} />

      <StationDetailTable station={station} />

      <RmvStationLink station={station} />

      <Stack alignItems="flex-end">
        {station && ability?.can(Action.UPDATE, Subject.Station) ? (
          <ButtonLink
            color="primary"
            params={{ stationId: station.id }}
            to="/management/stations/$stationId"
            variant="contained"
          >
            Bearbeiten
          </ButtonLink>
        ) : null}
      </Stack>
    </DetailSidebarContent>
  );
}
